module.exports = __webpack_public_path__ + "static/media/9_of_spades.46304258.svg";